import React from 'react';
import { Radius } from '@ghosts-inc/design-system/constants';
import { StockX } from '@ghosts-inc/design-system/icons';
import Stack, { StackProps } from '@mui/material/Stack';

export const StockXCircleIcon = ({
  boxProps = {},
  iconSize = 24,
}: {
  boxProps?: StackProps;
  iconSize?: number;
}) => {
  return (
    <Stack
      alignItems="center"
      bgcolor="#006340"
      borderRadius={Radius.round}
      data-testid="stockx-icon"
      height={iconSize}
      justifyContent="center"
      width={iconSize}
      {...boxProps}
    >
      <StockX sx={{ width: 'auto', height: 'auto' }} htmlColor="white" />
    </Stack>
  );
};
